import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ControlContainer, FormControl, FormGroup } from "@angular/forms";
import { Cidade, Estado } from "@tivic-team/manager-ts/dist/grl";
import { CidadeSearch } from "app/services/grl/cidade.search";
import { CidadeService } from "app/services/grl/cidade.service";
import { EstadoService } from "app/services/grl/estado.service";
import { ParentFormGroup } from "app/tools/parent-formgroup";
import { EMPTY, from, Observable } from "rxjs";
import { filter, map, mergeMap, tap } from "rxjs/operators";

@Component({
  selector: "auto-complete-cidade",
  templateUrl: "./auto-complete-cidade.component.html",
  styleUrls: ["./auto-complete-cidade.component.scss"],
  viewProviders: [ParentFormGroup]
})
export class AutoCompleteCidadeComponent implements OnInit {

  cidades: Cidade[];
  formGroup: FormGroup;

  @ViewChild("cdCidade", { static: false }) cdCidade: ElementRef;
  @ViewChild("sgEstado", { static: false }) sgEstado: ElementRef;
  private _cdCidade;

  constructor(
    private _cidadeService: CidadeService,
    private _estadoService: EstadoService,
    private _controlContainer: ControlContainer
  ) { }

  async ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.formGroup.addControl('cidade', new FormControl());
    

    this.formGroup.get('cidade').valueChanges
    .pipe(
      filter(keyword => this._validarTexto(keyword)),
      mergeMap(keyword => this._buscar(keyword)),
      tap(cidades => this._finalizarBusca(cidades))
    ).subscribe();
  }

  async ngAfterViewInit() {
    this.formGroup.get('cdCidade').valueChanges.pipe(
      mergeMap(cdCidade => this._carregar(cdCidade)),
      map(cidade => this.cidadeSelecionada(cidade)),
    ).subscribe();
  }

  limparCidade() {
    this._cdCidade = null;
    this.sgEstado.nativeElement.value = '';
    this.formGroup.patchValue({ cdCidade: null });
    this.formGroup.markAsDirty();
  }

  cidadeSelecionada(cidade: Cidade) {
    if (!cidade) return;

    this.alterarEstado(cidade);
    this._cdCidade = cidade.cdCidade;
    this.cdCidade.nativeElement.value = cidade.nmCidade;
    this.formGroup.patchValue({ cdCidade: cidade.cdCidade, cidade: cidade }, {emitEvent: false});
    this.formGroup.markAsDirty();
  }

  displayFn(cidade: Cidade) {
    return cidade ? cidade.nmCidade : ''
  }

  async alterarEstado(cidade?: Cidade) {
    if (cidade && cidade.cdEstado > 0) {
      let estado: Estado = await this._estadoService.get(cidade.cdEstado);
      this.sgEstado.nativeElement.value = estado.sgEstado;
    }
  }

  private _carregar(cdCidade): Observable<Cidade> {
    if (!cdCidade || isNaN(cdCidade) || this._cdCidade === cdCidade) {
      return EMPTY;
    }

    return from(this._cidadeService.get(cdCidade));
  }

  private _validarTexto(keyword: string){
    return keyword && keyword.length > 3;
  }

  private _buscar(keyword: string){
    return from(this._cidadeService.find(
      new CidadeSearch({ nmCidade: keyword })
    ));
  }

  private _finalizarBusca(resultado: Cidade[]){
    this.cidades = resultado
  }
}

